import { ERRORS_PATH } from "./internal/constants";
import { path } from "../fp";

// {a} -> a | Undefined
const getErrors = path(ERRORS_PATH);

export default getErrors;
